var _this = this;
import * as tslib_1 from "tslib";
import { lazySelectPreviousNodeInternal } from 'owa-mail-folder-forest-actions';
import { selectPreviousNode } from 'owa-mail-search';
import { orchestrator } from 'satcheljs';
/**
 * This orchestrator dispatches an internal action to handle the action so we
 * can lazy load the orchestrator.
 */
export default orchestrator(selectPreviousNode, function (actionMessage) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    var selectPreviousNodeInternal;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, lazySelectPreviousNodeInternal.import()];
            case 1:
                selectPreviousNodeInternal = _a.sent();
                selectPreviousNodeInternal(actionMessage.actionSource);
                return [2 /*return*/];
        }
    });
}); });
//# sourceMappingURL=selectPreviousNodeOrchestrator.js.map